import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { TooltipService } from '@common/services/tooltip.service';
import { main } from '@core/operators';
import { Device } from '@core/utilities/device';

const ICON_WIDTH = 10;
const ICON_MARGIN = 5;

@Component({
  selector: 'els',
  templateUrl: './ellipsis.component.html',
  styleUrls: ['./ellipsis.component.scss']
})
export class EllipsisComponent implements OnInit {  

  private placeholder: HTMLElement;

  private sizes: { width: number, min: number };
  private tails: { text: string, width: number }[];

  @Input()
  public words: number = 3;

  public get mobile() {
    return Device.mobile;
  }

  private get DOM(): { container: HTMLElement, content: HTMLElement, tail: HTMLElement, icon: HTMLElement } {

    let dom = {
      container: document.createElement('div'),
      content: document.createElement('div'),
      tail: document.createElement('div'),
      icon: document.createElement('i')
    };

    dom.icon.className = 'fa fa-question-circle small opacity-50';
    dom.icon.style.marginLeft = ICON_MARGIN + 'px';
    dom.icon.style.width = ICON_WIDTH + 'px';
    dom.icon.style.textAlign = 'center';

    dom.container.appendChild(dom.content);
    dom.container.appendChild(dom.tail);
    dom.container.appendChild(dom.icon);

    dom.content.addEventListener('mouseover', () => this.mouseover());       
    dom.icon.addEventListener('click', e => this.click(e));

    return dom;
  }

  public update(content: boolean) {

    main(() => this.render(content));      
  }

  private render(content: boolean) {
    
    if (content || this.ref.nativeElement.children.length < 2) {

      let text = this.placeholder.innerText;      
      let words = text.split(' ').takeLast(this.words);

      let css = getComputedStyle(this.placeholder);

      this.tails = words.map((i, x) => {
        let text = words.skip(x).join(' ');
        return { text: text, width: text.measure(css.font).width }
      });

      this.sizes = { min: text.length > 0 ? (text[0] + '...').measure(css.font).width : 0, width: text.measure(css.font).width };
    }

    let doc = new DocumentFragment();
    let width = this.placeholder.getBoundingClientRect().width;

    let dom = this.DOM;

    doc.appendChild(dom.container);

    dom.content.textContent = this.placeholder.textContent;
    dom.container.style.width = width + "px";
    dom.container.style.marginRight = '-' + width + 'px';

    if (this.overflow) {
      if (!Device.mobile) dom.icon.classList.add('hidden');

      let threshold = width - (ICON_WIDTH + ICON_MARGIN) - this.sizes.min;
      dom.tail.textContent = this.tails.first(i => i.width < threshold, { text: '', width: 0 }).text;
    }
    else {
      dom.tail.textContent = '';
      dom.icon.classList.add('hidden');
    }    

    let e = (this.ref.nativeElement as HTMLElement);

    if (e.children.length > 1) {
      e.replaceChild(doc, e.children[1]);
    }
    else {
      e.appendChild(doc)
    }
  }

  public get overflow() {
    return this.placeholder.getBoundingClientRect().width < this.sizes.width;
  }

  constructor(private ref: ElementRef, private tooltip: TooltipService) {   
  }

  public click(e: UIEvent) {
    this.tooltip.show(this.placeholder.textContent, this.ref.nativeElement);
    e.stopPropagation();
  }

  public mouseover() {
    if (!Device.mobile && this.overflow) {
      this.tooltip.show(this.placeholder.textContent, this.ref.nativeElement);
    }
  }  

  ngOnInit() {
    this.placeholder = (this.ref.nativeElement as HTMLElement).firstElementChild as HTMLElement;
  }
}
